import { render, staticRenderFns } from "./StaffEditor.vue?vue&type=template&id=fbed8cf2"
import script from "./StaffEditor.vue?vue&type=script&lang=js"
export * from "./StaffEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports